import { backgroundOrange } from '@/theme/colors'
import styled from 'styled-components'

export const IdeasPageContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${backgroundOrange};
	overflow: hidden;
`

export const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	font-size: 18px;
	color: #6b7280;
`

export const ErrorContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	font-size: 18px;
	color: #dc2626;
`
